import { datalabHttp } from '@dbl/services/common';
import { AxiosPromise } from 'axios';

export const initFieldService: (params: { game_code: string; }) => AxiosPromise<any> = (params) =>
  datalabHttp({
    url: '/api/v1/datalab/getExploreAnalysisTableInfo',
    method: 'post',
    data: params,
    timeout: 120000,
  });

// 获取chat对话结果
export const requestChatResult = (params: any) =>
  datalabHttp({
    url: '/api/v1/datalab/completion',
    method: 'post',
    data: params,
    timeout: 120000,
  });

// 根据SQL获取表格数据
export const getTableData = (params: any) =>
  datalabHttp({
    url: '/api/v1/datalab/exec_sql',
    method: 'post',
    data: params,
    timeout: 120000,
  });